﻿import $ from 'jquery'
import ko from 'knockout'
import _ from 'underscore';
import { Element as RustigElement } from '../utilities/element';

declare global {

  interface JQuery {
    multiselecttable(): JQuery;
    multiselecttablerow: Function;
  }
}

export class MultiSelectTable {
  static get wireup(): string {
    return 'table.multiselect';
  }
  static isMultiSelect($element: JQuery): boolean {
    return $element.is(this.wireup);
  }
  public get tableKey(): string {
    return this.$table.data('multiselect-key');
  }

  public get selectAllElement(): RustigElement {
    let selector = 'multiselect-key'.asDataSelector(this.tableKey) + ' ' + 'multiselect-selectall'.asDataSelector();
    return new RustigElement($(selector));
  }

  selected: any;
  anySelected: any;
  all: any[];
  allSelected: any;

  constructor(private $table: JQuery) {
    this.$table.addClass('multiselect')
      .attr('data-multiselecttable', 'on');
    
    this.selected = ko.observableArray();
    this.allSelected = ko.pureComputed(() => {
      let selected = this.selected().length;
      let all = this.all.length;
      let isSelectAll = selected === all;

      return isSelectAll;
    });

    this.anySelected = ko.computed(() => {
      return this.selected().length > 0;
    });

    if (this.tableKey) {
      this.bindExternal(this.tableKey);
    }

    this.validateMarkup();
    this.koInit();

    this.$table.data("rustig.multiselecttable", this);
    this.initializeJsonValues();

    this.allSelected.subscribe((isSelectAll) => {
      this.onSelectAllChanged(isSelectAll);
    });
  }

  public addRow($row: JQuery) {
    $row.attr("data-bind", "css:{ selected: isRowSelected($element)}, click: selectRow");
    $row.find('input[type="checkbox"]').attr("data-bind", "checked: selected").attr('data-multiselect-selector', 'true');
    this.updateAll();
    ko.applyBindings(this, $row[0]);
  }

  selectAll() {
    let value = this.allSelected();
    if (value) {
      this.selected.removeAll();
      this.$table.find("tbody tr").removeClass("selected");
    } else {
      this.selected(this.all.slice(0));
      this.$table.find("tbody tr").addClass("selected");
    }

    return this.onSelectedChanged();
  }

  isSelectAllChecked(): boolean {
    return this.selectAllElement.value() as boolean
  }

  selectRow(data, e) {
    let target = $(e.target);
    let textIsHighlighted = getSelection().toString();
    if (target.is("a") || target.is("input") || textIsHighlighted)
      return this.onSelectedChanged();

    let $selector = target.closest("tr").find("[data-multiselect-selector]");
    if (e.ctrlKey) {
      this.toggle($selector.val());
      return this.onSelectedChanged();
    }

    let wasSelected = _.contains(this.selected(), $selector.val());
    this.selected.removeAll();
    this.$table.find("tbody tr").removeClass("selected");
    if (!wasSelected)
      this.toggle($selector.val());

    return this.onSelectedChanged();
  }

  selectRowElement($row: JQuery) {
    let selector = $row.find('[data-multiselect-selector]');
    this.toggle(selector.val());
    return true;
  }

  toggle(value: any) {
    let index = this.selected().indexOf(value);
    if (index === -1)
      this.selected.push(value);
    else
      this.selected.splice(index, 1);
  }

  isRowSelected(element) {
    let val = $(element).find("[data-multiselect-selector]").val();
    return this.selected.indexOf(val) >= 0;
  }

  destroy(): void {
    ko.cleanNode(this.$table[0]);
    this.$table.removeClass("multiselect");
    this.$table.removeData("rustig.multiselecttable");
  }
  refresh(): void {
    ko.cleanNode(this.$table[0]);
    this.koInit();

    this.$table.data("rustig.multiselecttable", this);
  }

  onSelectedChanged(): boolean {
    let $count = $('multiselect-selected-row-count'.asDataSelector(this.tableKey));
    if ($count.length == 0)
      return true;

    let selectedCount = this.selected().length;
    let rCount = new RustigElement($count);
    if (rCount.isInput)
      rCount.value(selectedCount);
    else
      rCount.text(selectedCount);

    return true;
  }

  private onSelectAllChanged(isSelectAll) {
    this.$table.trigger('allSelectedChanged.rustig.multiselecttable', [{ isSelectAll: isSelectAll }]);
  }

  private koInit(): void {
    this.updateAll();
    this.createBinders();
    ko.applyBindings(this, this.$table[0]);
  }

  private createBinders(): void {
    this.$table.attr("data-bind", "attr:{ 'data-table-selected' : ko.toJSON(selected), 'data-table-all' : ko.toJSON(all)}");

    this.$table.find("tbody tr:not('.table-more-row')").each(function () {
      $(this).attr("data-bind", "css:{ selected: isRowSelected($element)}, click: selectRow");
    });

    this.$table.find("td input[type='checkbox']").each(function () {
      $(this).attr("data-bind", "checked: selected");
      $(this).attr("data-multiselect-selector", "true");
    });

    this.$table.find("th input[type='checkbox']")
      .attr("data-multiselect-selectall", "true")
      .attr("data-bind", "click: selectAll, checked: allSelected");

  }

  private bindExternal(key: string): void {
    let json = ko.computed(() => {
      return ko.toJSON(this.selected);
    });

    json.subscribe((v) => {
      $('multiselect-json'.asDataSelector(key))
        .each(function () {
          $(this).val(v);
        });
    });

    this.anySelected.subscribe((v) => {
      $('multiselect-any'.asDataSelector(key))
        .each(function () {
          if (v)
            $(this).enable();
          else
            $(this).disable();
        });
    });

  }

  private validateMarkup(): void {
    if (!this.$table.is("table"))
      throw new Error("Multiselect table must be initiated on a <table> element");
  }
  private updateAll(): void {
    let ids = [];
    let _this = this;
    this.$table.find("td input[type='checkbox']").each(function () {
      let id = $(this).val();
      ids.push(id);

      let isSelected = !!(new RustigElement($(this)).value());
      if (isSelected)
        _this.selected.push(id);
    });

    this.all = ids;
    this.onSelectedChanged();
  }

  private initializeJsonValues(): void {
    if (this.tableKey === undefined)
      return;

    let initialJson = ko.toJSON(this.selected);
    $('multiselect-json'.asDataSelector(this.tableKey))
      .each(function () {
        $(this).val(initialJson);
      });
  }
}

(function ($) {
  function Plugin() {
    return this.each(function () {
      let $this = $(this);
      let table = $this.data('rustig.multiselecttable');

      if (!table) {
        new MultiSelectTable($this);
      }
      else {
        table.refresh();
      }
    });
  }
  $.fn.multiselecttable = Plugin;
  $.fn.multiselecttablerow = function () {
    this.each(function () {
      let table = <MultiSelectTable>$(this).closest('table.multiselect').data('rustig.multiselecttable');

      if (!table)
        return true;

      table.addRow($(this).closest('tr'));
    });
  };
})($);